import { countryCityConstants } from "../constants/countryCityConstants";
import { countryCityService } from "../../services/API/countryCityService";
import { history } from "../store/configureStore";

export const countryCityActions = {
  getStateData,
  getCityData,
  get_city_ByState,
  get_country_data,
  get_all_city,
  delete_city,
  get_city_details
};
function getStateData(countryNameParams) {
  return dispatch => {
    dispatch(request());
    countryCityService.get_state(countryNameParams).then(
      states => {
        dispatch(success(states));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(states) {
    return { type: countryCityConstants.FETCH_STATE_REQUEST, states };
  }
  function success(states) {
    return { type: countryCityConstants.FETCH_STATE_SUCCESS, states };
  }
  function failure(error) {
    return { type: countryCityConstants.FETCH_STATE_FAILURE, error };
  }
}

function getCityData() {
  return dispatch => {
    dispatch(request());
    countryCityService.get_all_city().then(
      cities => {
        dispatch(success(cities));
      },
      error => {
        dispatch(failure("getCityData error: " + error.toString()));
      }
    );
  };

  function request(cities) {
    return { type: countryCityConstants.FETCH_CITIES_REQUEST, cities };
  }
  function success(cities) {
    return { type: countryCityConstants.FETCH_CITIES_SUCCESS, cities };
  }
  function failure(error) {
    return { type: countryCityConstants.FETCH_CITIES_FAILURE, error };
  }
}

function get_country_data() {
  return dispatch => {
    dispatch(request());
    countryCityService.get_country_data().then(
      countries => {
        dispatch(success(countries));
      },
      error => {
        dispatch(failure("getCountryData error: " + error.toString()));
      }
    );
  };

  function request(countries) {
    return { type: countryCityConstants.FETCH_COUNTRIES_REQUEST, countries };
  }
  function success(countries) {
    return { type: countryCityConstants.FETCH_COUNTRIES_SUCCESS, countries };
  }
  function failure(error) {
    return { type: countryCityConstants.FETCH_COUNTRIES_FAILURE, error };
  }
}

export const get_country = () => {
  return dispatch => {
    dispatch(request());
    countryCityService.get_country_data().then(
      countries => {
        dispatch(success(countries));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(countries) {
    return { type: countryCityConstants.FETCH_COUNTRIES_REQUEST, countries };
  }
  function success(countries) {
    return { type: countryCityConstants.FETCH_COUNTRIES_SUCCESS, countries };
  }
  function failure(error) {
    return { type: countryCityConstants.FETCH_COUNTRIES_FAILURE, error };
  }
};

export const add_city = postData => {
  return dispatch => {
    dispatch(request());
    countryCityService.add_city(postData).then(
      city => {
        dispatch(success(city));
        history.push("/cityAndCountry");
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(city) {
    return { type: countryCityConstants.ADD_CITY_REQUEST, city };
  }
  function success(city) {
    return { type: countryCityConstants.ADD_CITY_SUCCESS, city };
  }
  function failure(error) {
    return { type: countryCityConstants.ADD_CITY_FAILURE, error };
  }
};

export const get_state = countryNameParams => {
  return dispatch => {
    dispatch(request());
    countryCityService.get_state(countryNameParams).then(
      states => {
        dispatch(success(states));
      },

      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(states) {
    return { type: countryCityConstants.FETCH_STATE_REQUEST, states };
  }
  function success(states) {
    return { type: countryCityConstants.FETCH_STATE_SUCCESS, states };
  }
  function failure(error) {
    return { type: countryCityConstants.FETCH_STATE_FAILURE, error };
  }
};

export const get_all_city = formData => {
  return dispatch => {
    dispatch(request());
    countryCityService.get_all_city(formData).then(
      cities => {
        dispatch(success(cities));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(cities) {
    return { type: countryCityConstants.FETCH_CITIES_REQUEST, cities };
  }
  function success(cities) {
    return { type: countryCityConstants.FETCH_CITIES_SUCCESS, cities };
  }
  function failure(error) {
    return { type: countryCityConstants.FETCH_CITIES_FAILURE, error };
  }
};

export const delete_city = cityIdASParams => {
  return dispatch => {
    dispatch(request());
    countryCityService.delete_city(cityIdASParams).then(
      city => {
        dispatch(success(city));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(city) {
    return { type: countryCityConstants.DELETE_CITY_REQUEST, city };
  }
  function success(city) {
    return { type: countryCityConstants.DELETE_CITY_SUCCESS, city };
  }
  function failure(error) {
    return { type: countryCityConstants.DELETE_CITY_FAILURE, error };
  }
};

export const get_city_details = cityIdParams => {
  return dispatch => {
    dispatch(request());
    countryCityService.get_city_details(cityIdParams).then(
      cityDetails => {
        dispatch(success(cityDetails));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(cityDetails) {
    return { type: countryCityConstants.GET_CITY_DETAILS_REQUEST, cityDetails };
  }
  function success(cityDetails) {
    return { type: countryCityConstants.GET_CITY_DETAILS_SUCCESS, cityDetails };
  }
  function failure(error) {
    return { type: countryCityConstants.GET_CITY_DETAILS_FAILURE, error };
  }
};

export const update_city = postData => {
  return dispatch => {
    dispatch(request());
    countryCityService.update_city(postData).then(
      updatedCity => {
        dispatch(success(updatedCity));
        history.push("/cityAndCountry");
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(updatedCity) {
    return { type: countryCityConstants.UPDATE_CITY_REQUEST, updatedCity };
  }
  function success(updatedCity) {
    return { type: countryCityConstants.UPDATE_CITY_SUCCESS, updatedCity };
  }
  function failure(error) {
    return { type: countryCityConstants.UPDATE_CITY_FAILURE, error };
  }
};

function get_city_ByState(stateAbbr) {
  return dispatch => {
    dispatch(request());
    countryCityService.get_citydetails_ByState(stateAbbr).then(
      cityDetailsByState => {
        dispatch(success(cityDetailsByState));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(cityDetailsByState) {
    return {
      type: countryCityConstants.GET_CITY_DETAILS_BYSTATE_REQUEST,
      cityDetailsByState
    };
  }
  function success(cityDetailsByState) {
    return {
      type: countryCityConstants.GET_CITY_DETAILS_BYSTATE_SUCCESS,
      cityDetailsByState
    };
  }
  function failure(error) {
    return {
      type: countryCityConstants.GET_CITY_DETAILS_BYSTATE_FAILURE_,
      error
    };
  }
}

export const get_timezone = () => {
  return dispatch => {
    dispatch(request());
    countryCityService.get_timezone().then(
      timezone => {
        dispatch(success(timezone));
      },

      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(timezone) {
    return { type: countryCityConstants.FETCH_TIMEZONE_REQUEST, timezone };
  }
  function success(timezone) {
    return { type: countryCityConstants.FETCH_TIMEZONE_SUCCESS, timezone };
  }
  function failure(error) {
    return { type: countryCityConstants.FETCH_TIMEZONE_FAILURE, error };
  }
};



// WEBPACK FOOTER //
// ./src/app/redux/actions/countryCityActions.js